import React, { useEffect } from "react";
import "../../../css/Checks/CheckHelpModal.css";
import { ReactComponent as CloseIcon } from "../../../assets/icons/close.svg";
import { ReactComponent as TickIcon } from "../../../assets/icons/checkCircleFilled.svg";
import { ReactComponent as CrossIcon } from "../../../assets/icons/closeCircleFilled.svg";

const Tick = ({ show }) => (
  <span className={`aml-check-tick ${show ? "is-on" : ""}`} aria-hidden="true">
    {show ? <TickIcon /> : <CrossIcon />}
  </span>
);

const CheckHelpModal = ({ open, onClose }) => {
  //  Hook always called; logic gated by open
  useEffect(() => {
    if (!open) return;

    const onKeyDown = (e) => {
      if (e.key === "Escape") onClose();
    };

    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      className="aml-check-help-modal-overlay"
      role="dialog"
      aria-modal="true"
      aria-label="Which AML check should I use?"
      onMouseDown={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div className="aml-check-help-modal">
        {/* Header */}
        <div className="aml-check-help-modal-header">
          <div className="AML-Text-Subtitle">Which check should I run?</div>

          <button
            type="button"
            className="aml-check-help-close-btn"
            onClick={onClose}
            aria-label="Close"
            title="Close"
          >
            <CloseIcon />
          </button>
        </div>

        {/* Body */}
        <div className="aml-check-help-modal-body">
          <div className="aml-check-help-table-wrap">
            <table className="aml-check-help-table">
              <thead>
                <tr>
                  <th className="col-scenario">
                    <div className="AML-Text-Input">Scenario/ Client Type</div>
                  </th>
                  <th className="col-center">
                    <div className="AML-Text-Input">Enhanced</div>
                  </th>
                  <th className="col-center">
                    <div className="AML-Text-Input">Standard</div>
                  </th>
                  <th className="col-center">
                    <div className="AML-Text-Input">PEP & Sanctions</div>
                  </th>

                  {/* If you want to show Simple column only when allowed */}
                  {/* {canShowSimple && (
                    <th className="col-center">
                      <div className="AML-Text-Input">Simple</div>
                    </th>
                  )} */}
                </tr>
              </thead>

              <tbody>
                <tr>
                  <td className="scenario-cell">
                    <div className="AML-Text-Body">
                      <span className="AML-Text-Input">New</span> client whom
                      you have <span className="AML-Text-Input">not met</span>{" "}
                      face-to-face or via video call.
                    </div>
                  </td>
                  <td className="col-center">
                    <Tick show />
                  </td>
                  <td className="col-center">
                    <Tick show={false} />
                  </td>
                  <td className="col-center">
                    <Tick show={false} />
                  </td>
                  {/* {canShowSimple && (
                    <td className="col-center">
                      <Tick show={false} />
                    </td>
                  )} */}
                </tr>

                <tr>
                  <td className="scenario-cell">
                    <div className="AML-Text-Body">
                      <span className="AML-Text-Input">New</span> client whom
                      you <span className="AML-Text-Input">have met</span>{" "}
                      face-to-face, or via video call.
                    </div>
                  </td>
                  <td className="col-center">
                    <Tick show={false} />
                  </td>
                  <td className="col-center">
                    <Tick show />
                  </td>
                  <td className="col-center">
                    <Tick show={false} />
                  </td>
                  {/* {canShowSimple && (
                    <td className="col-center">
                      <Tick show={false} />
                    </td>
                  )} */}
                </tr>

                <tr>
                  <td className="scenario-cell">
                    <div className="AML-Text-Body">
                      <span className="AML-Text-Input">Existing</span> client,
                      but their ID document has been updated.
                    </div>
                  </td>
                  <td className="col-center">
                    <Tick show={false} />
                  </td>
                  <td className="col-center">
                    <Tick show />
                  </td>
                  <td className="col-center">
                    <Tick show={false} />
                  </td>
                  {/* {canShowSimple && (
                    <td className="col-center">
                      <Tick show={false} />
                    </td>
                  )} */}
                </tr>

                <tr>
                  <td className="scenario-cell">
                    <div className="AML-Text-Body">
                      <span className="AML-Text-Input">Existing</span> client
                      but their details{" "}
                      <span className="AML-Text-Input">have changed</span> (e.g.
                      moved house / changed name).
                    </div>
                  </td>
                  <td className="col-center">
                    <Tick show={false} />
                  </td>
                  <td className="col-center">
                    <Tick show />
                  </td>
                  <td className="col-center">
                    <Tick show={false} />
                  </td>
                  {/* {canShowSimple && (
                    <td className="col-center">
                      <Tick show={false} />
                    </td>
                  )} */}
                </tr>

                <tr>
                  <td className="scenario-cell">
                    <div className="AML-Text-Body">
                      <span className="AML-Text-Input">Existing</span> client
                      who you are doing new business for, & you already have a{" "}
                      <span className="AML-Text-Input">
                        valid Smart Search ID check
                      </span>{" "}
                      carried out in the{" "}
                      <span className="AML-Text-Input">last 5 years</span>.
                      {/* <span className="AML-Text-Input">have not changed</span>. */}
                    </div>
                  </td>
                  <td className="col-center">
                    <Tick show={false} />
                  </td>
                  <td className="col-center">
                    <Tick show={false} />
                  </td>
                  <td className="col-center">
                    <Tick show />
                  </td>
                  {/* {canShowSimple && (
                    <td className="col-center">
                      <Tick show={false} />
                    </td>
                  )} */}
                </tr>

                {/* Example of PEPs & Sanctions scenario row (optional) */}
                {/* <tr>
                  <td className="scenario-cell">
                    <div className="AML-Text-Body">
                      You only need watchlist screening (PEPs / sanctions) as an
                      additional or standalone screening step.
                    </div>
                  </td>
                  <td className="col-center">
                    <Tick show={false} />
                  </td>
                  <td className="col-center">
                    <Tick show={false} />
                  </td>
                  <td className="col-center">
                    <Tick show />
                  </td>
                  
                  {canShowSimple && (
                    <td className="col-center">
                      <Tick show={false} />
                    </td>
                  )}
                </tr> */}
              </tbody>
            </table>
          </div>

          {/* <div className="AML-Text-Body aml-check-help-note">
            Tip: If you’re unsure, start with <b>Standard</b> and escalate to{" "}
            <b>Enhanced</b> if additional risk indicators arise.
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default CheckHelpModal;
